// One canonical photo per salon. The multi-image galleries/carousels were
// retired in favour of a single hero image used everywhere (landing, mega menu,
// branches list, individual salon hero). Each salon ships two encoded variants:
//   hero.webp       - full-size, for the large salon-detail hero
//   hero-560w.webp  - 560px-wide variant, for cards / mega-menu thumbnails
// The obsolete per-salon image folders' other files are slated for deletion.
const SALON_IDS = ['vanlose', 'vaerlose', 'horsholm', 'farum', 'allerod'] as const

/** Full-size hero image for a salon (used by the salon-detail hero). */
export function getSalonImage(salonId: string): string {
  return `/images/saloon-images/${salonId}/hero.webp`
}

/** 560px-wide variant for cards / mega-menu thumbnails. */
export function getSalonThumb(salonId: string): string {
  return `/images/saloon-images/${salonId}/hero-560w.webp`
}

/**
 * Back-compat: surfaces that previously consumed a gallery array now receive a
 * single-element array (the 560w thumb). Carousel logic that loops over this
 * collapses to a static image. Prefer getSalonImage / getSalonThumb for new code.
 */
export function getSalonImages(salonId: string): string[] {
  return [getSalonThumb(salonId)]
}

/** All salon thumbs, one per salon - used as the (now static) hero pool. */
export const allSalonImages: string[] = SALON_IDS.map(getSalonThumb)
